// components/AuthLoader/index.js
// Loader a pantalla completa que respeta la paleta del sistema (info + primary).
import PropTypes from 'prop-types';
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import brand from 'assets/images/logos/circle-logo.png';

const keyframes = `
@keyframes cargosys-spin { to { transform: rotate(360deg); } }
@keyframes cargosys-pulse {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(0.92); opacity: 0.85; }
}
@keyframes cargosys-dots {
  0%, 80%, 100% { opacity: 0.2; }
  40% { opacity: 1; }
}
`;

function AuthLoader({ label = 'Cargando CargoSys...' }) {
  return (
    <SoftBox
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      width="100%"
      sx={{ backgroundColor: '#f8f9fa' }}
    >
      <style>{keyframes}</style>

      {/* Anillo giratorio con el logo pulsando al centro */}
      <SoftBox
        position="relative"
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{ width: '96px', height: '96px' }}
      >
        <SoftBox
          position="absolute"
          sx={{
            width: '96px',
            height: '96px',
            borderRadius: '50%',
            border: '4px solid rgba(23, 193, 232, 0.15)',
            borderTopColor: '#17c1e8',
            borderRightColor: '#cb0c9f',
            animation: 'cargosys-spin 0.9s linear infinite',
          }}
        />
        <SoftBox
          component="img"
          src={brand}
          alt="CargoSys"
          sx={{
            width: '56px',
            height: '56px',
            borderRadius: '50%',
            objectFit: 'cover',
            animation: 'cargosys-pulse 1.4s ease-in-out infinite',
          }}
        />
      </SoftBox>

      <SoftBox mt={3} display="flex" alignItems="center">
        <SoftTypography
          variant="button"
          fontWeight="medium"
          sx={{ color: '#67748e', letterSpacing: '0.02em' }}
        >
          {label}
        </SoftTypography>
        {[0, 1, 2].map((i) => (
          <SoftBox
            key={i}
            sx={{
              width: '5px',
              height: '5px',
              ml: '3px',
              borderRadius: '50%',
              backgroundColor: '#cb0c9f',
              animation: 'cargosys-dots 1.4s ease-in-out infinite',
              animationDelay: `${i * 0.16}s`,
            }}
          />
        ))}
      </SoftBox>
    </SoftBox>
  );
}

AuthLoader.propTypes = {
  label: PropTypes.string,
};

export default AuthLoader;
